import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioButtonChecked = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 9.6,
		fill: "#2563EB"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 4.8,
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgRadioButtonChecked);
export default ForwardRef;
